import React, { Component } from "react";
import _ from "lodash";
import * as echarts from "echarts";

const LineBaseConfig = {
  legend: {
    orient: 'horizontal',
    align: 'left'
  },
  backgroundColor: "transparent",
  grid: {
    left: '10',
    right: '10',
    bottom: '10',
    top: '20',
    containLabel: true
  },
  xAxis: {
    type: 'category',
  },
  yAxis: {
    type: 'value',
  },
  tooltip: {
    trigger: 'axis',
  },
};

const BarBaseConfig = {
  legend: {
    orient: 'horizontal',
    align: 'left'
  },
  backgroundColor: "transparent",
  grid: {
    left: '10',
    right: '10',
    bottom: '10',
    top: '20',
    containLabel: true
  },
  xAxis: {
    type: 'category',
  },
  yAxis: {
    type: 'value',
  },
  tooltip: {
    trigger: 'axis',
  },
}


const PieBaseConfig = {
  backgroundColor: 'transparent',
  tooltip: {
    trigger: 'item',
  },
}

const RadarBaseConfig = {
  backgroundColor: "transparent",
  tooltip: {
    trigger: 'item',
  },
}

export default class BaseChart extends Component{
  constructor(props){
    super(props);

    this.chartDomRef = null;
    this.chartRef = null;
    this.resizeObserver = null;
  }

  componentDidMount() {
    if(this.chartDomRef){
      this.chartRef = echarts.init(this.chartDomRef, "light", {
        locale: "ZH"
      });

      const handleResize = () => {
        this.chartRef.resize();
      };

      // 监听容器尺寸变化
      this.resizeObserver = new ResizeObserver(handleResize);
      if (this.chartRef) {
        this.resizeObserver.observe(this.chartDomRef);
      }
    }
  }

  componentWillUnmount() {
    if(this.chartRef){
      this.chartRef.dispose()
    }

    if(this.resizeObserver){
      this.resizeObserver.disconnect()
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.chartType !== this.props.chartType || nextProps.chartConfig !== this.props.chartConfig){
      let baseConfig = {};
      switch (nextProps.chartType) {
        case "line": {
          baseConfig = _.cloneDeep(LineBaseConfig);
          break;
        }
        case "bar": {
          baseConfig = _.cloneDeep(BarBaseConfig);
          break;
        }
        case "pie": {
          baseConfig = _.cloneDeep(PieBaseConfig);
          break;
        }
        case "radar": {
          baseConfig = _.cloneDeep(RadarBaseConfig);
          break;
        }
      }

      baseConfig = Object.assign(baseConfig, nextProps.chartConfig);

      if (this.chartRef) {
        this.chartRef.clear();
        this.chartRef.resize();
        this.chartRef.setOption(baseConfig);
      }
    }
  }


  render() {
    return <div
      ref={(ref)=>{this.chartDomRef = ref}}
      style={{ width: "100%", height: "100%" }}
    >
    </div>
  }
}